/**
 * third packages
 */

/**
 * export axios as AxiosNamespace
 */
export * as AxiosNamespace from "axios"
